import { general } from './general';

export const telephone = (data = {}) => general('telephone', (data || {}));
